export default __webpack_public_path__ + "/dist/images/406673.png";